import React from "react";
import "./news.layout.sass";
import newsData from "../../data/news/news.data";
import { Link } from "react-router-dom";
import { Button } from "rsuite";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectNews } from "../../redux/site/site.selector";
import { Setting } from "../../setting";
import GridLoader from "react-spinners/GridLoader";
import { css } from "@emotion/react";
import Axios from "axios";
import { SetNews } from "../../redux/site/site.actions";

const NewsLayout = ({ News, SetNews }) => {
  const override = css`
    display: block;
    margin: 40px auto;
    border-color: red;
    position: relative;
  `;
  if (!News) {
    Axios.get(`${Setting.apiUrl}api/news/list`).then((res) => {
      SetNews(res.data);
    });
  }
  return (
    <div className="products" style={{ backgroundColor: "transparent" }}>
      <div className="product-container">
        <h3>
          اخبار <span>زیتونیکس</span>
        </h3>
        <div className="product-area">
          {News ? (
            News.map((item) => (
              <div key={item.id} className="product">
                <img
                  src={`${Setting.apiUrl}${item.gallery[0].path}`}
                  alt="xitonix news"
                />
                <h5>{item.title}</h5>
                <div className="btn-add-area">
                  <Link to={`/news/${item.id}`}>
                    <Button>مشاهده</Button>
                  </Link>
                </div>
              </div>
            ))
          ) : (
            <GridLoader css={override} size={15} margin={8} color="#FF8F3C" />
          )}
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = createStructuredSelector({
  News: selectNews,
});
const mapDispatchToProps = (dispatch) => ({
  SetNews: (news) => dispatch(SetNews(news)),
});
export default connect(mapStateToProps, mapDispatchToProps)(NewsLayout);
